<template>
    <section class="container-fluid text-center">
        <div class="row">

            <!-- Awards Section -->
            <div id="awards" class="col-xl section-style d-flex">
                <div class="row justify-content-center align-self-center">
                    <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8">
                        <h2 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md white">Awards & recognitions</h2>
                        <p class="white">
                            As an award winning Ultimate Jet Vacations Company, we ensure our members remarkable service and accommodations, making us the ultimate experience
                        </p>
                    </div>
                </div>
            </div>

            <!-- Instagram Section -->
            <div id="instagram-col-1" class="col-xl d-none d-md-inline">
                <!-- Static Section -->
                <div v-if="!instagramAvailable" class="row justify-content-md-center h-100">
                    <div class="col-md-12 card-inside-cont-insta">
                        <div class="zoom-image">
                            <span class="zoom-image-hover"></span>
                            <img src="/assets/instagram/25018513_1562795490441665_1084350998811508736_n.jpg">
                            <div class="card-info row align-items-end">
                                <div class="col-auto mr-auto">
                                    <span class="col-md-auto padding-right-left-0">
                                        <i class="fa fa-instagram white align-middle" aria-hidden="true"></i>
                                    </span>
                                </div>
                                <div class="col-auto zoom-image-hover-info">
                                    <span class="col-md-auto white">
                                        <i class="material-icons align-middle">favorite_border</i> 27
                                    </span>
                                    <span class="col-md-auto padding-right-left-0 white">
                                        <i class="material-icons align-middle">chat_bubble_outline</i> 8
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 card-inside-cont-insta">
                        <div class="zoom-image">
                            <span class="zoom-image-hover"></span>
                            <img src="/assets/instagram/25024644_148332189223089_2778999709170139136_n.jpg">
                            <div class="card-info row align-items-end">
                                <div class="col-auto mr-auto">
                                    <span class="col-md-auto padding-right-left-0">
                                        <i class="fa fa-instagram white align-middle" aria-hidden="true"></i>
                                    </span>
                                </div>
                                <div class="col-auto zoom-image-hover-info">
                                    <span class="col-md-auto white">
                                        <i class="material-icons align-middle">favorite_border</i> 66
                                    </span>
                                    <span class="col-md-auto padding-right-left-0 white">
                                        <i class="material-icons align-middle">chat_bubble_outline</i> 56
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 card-inside-cont-insta">
                        <div class="zoom-image">
                            <span class="zoom-image-hover"></span>
                            <img src="/assets/instagram/24845178_508799259503823_7889177048063672320_n.jpg">
                            <div class="card-info row align-items-end">
                                <div class="col-auto mr-auto">
                                    <span class="col-md-auto padding-right-left-0">
                                        <i class="fa fa-instagram white align-middle" aria-hidden="true"></i>
                                    </span>
                                </div>
                                <div class="col-auto zoom-image-hover-info">
                                    <span class="col-md-auto white">
                                        <i class="material-icons align-middle">favorite_border</i> 12
                                    </span>
                                    <span class="col-md-auto padding-right-left-0 white">
                                        <i class="material-icons align-middle">chat_bubble_outline</i> 6
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Dynamic Section -->
                <div v-if="instagramAvailable" class="row justify-content-md-center">
                    <div class="card-inside-cont-insta" v-for="index in totalPosts - 1" :class="{'col-md-12': index === 1, 'col-md-6': index !== 1}" @click="openPost(index - 1)">
                        <div class="zoom-image">
                            <span class="zoom-image-hover"></span>
                            <img :src="posts[index - 1].media_url">
                            <div class="card-info row align-items-end">
                                <div class="col-auto mr-auto">
                                    <span class="col-md-auto padding-right-left-0">
                                        <i class="fa fa-instagram white align-middle" aria-hidden="true"></i>
                                    </span>
                                </div>
                                <div class="col-auto zoom-image-hover-info">
                                    <span class="col-md-auto white">
                                        <i class="material-icons align-middle">favorite_border</i> {{ posts[index - 1].like_count }}
                                    </span>
                                    <span class="col-md-auto padding-right-left-0 white">
                                        <i class="material-icons align-middle">chat_bubble_outline</i> {{ posts[index - 1].comments_count }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="instagram-col-2" class="col-lg-3">

                <!-- Static Section -->
                <div v-if="!instagramAvailable" class="row justify-content-md-center">
                    <div class="col-md-12 card-inside-cont-insta">
                        <div class="zoom-image">
                            <span class="zoom-image-hover"></span>
                            <img src="/assets/instagram/25008095_132214844115594_5947160718494138368_n.jpg">
                            <div class="card-info row align-items-end">
                                <div class="col-auto mr-auto">
                                    <span class="col-md-auto padding-right-left-0">
                                        <i class="fa fa-instagram white align-middle" aria-hidden="true"></i>
                                    </span>
                                </div>
                                <div class="col-auto zoom-image-hover-info">
                                    <span class="col-md-auto white zoom-image float-left">
                                        <i class="material-icons align-middle">favorite_border</i> 34
                                    </span>
                                    <span class="col-md-auto padding-right-left-0 white">
                                        <i class="material-icons align-middle">chat_bubble_outline</i> 12
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Dynamic Section -->
                <div v-if="instagramAvailable" class="row justify-content-md-center">
                    <div class="col-md-12 card-inside-cont-insta" @click="openPost(totalPosts - 1)">
                        <div class="zoom-image">
                            <span class="zoom-image-hover"></span>
                            <img :src="lastPost.media_url">
                            <div class="card-info row align-items-end">
                                <div class="col-auto mr-auto">
                                    <span class="col-md-auto padding-right-left-0">
                                        <i class="fa fa-instagram white align-middle" aria-hidden="true"></i>
                                    </span>
                                </div>
                                <div class="col-auto zoom-image-hover-info">
                                    <span class="col-md-auto white zoom-image float-left">
                                        <i class="material-icons align-middle">favorite_border</i> {{ lastPost.like_count }}
                                    </span>
                                    <span class="col-md-auto padding-right-left-0 white">
                                        <i class="material-icons align-middle">chat_bubble_outline</i> {{ lastPost.comments_count }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Share your experiences -->
                <div id="share-exp-cont" class="h-100 row justify-content-center">
                    <div class="col-12">
                        <div class="margin-top-50 d-inline-block">
                            <h2 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md white">Share your experiences</h2>
                            <p class="font-md white">
                                By tagging <strong>@Ultimatejetvacations</strong>
                            </p>
                            <section-social-media></section-social-media>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import SectionSocialMedia from './SocialMedia';

    export default {
        components: { SectionSocialMedia },

        created() {
            this.initialize();
        },

        computed: {
            instagramAvailable() {
                return this.posts.length >= this.totalPosts;
            },
            lastPost() {
                return this.posts[this.totalPosts - 1];
            }
        },

        data() {
            return {
                totalPosts: 4,
                posts : []
            }
        },

        methods: {
            initialize() {
                this.refreshPosts();
            },

            openPost(index) {
                window.open(this.posts[index].permalink, "_blank");
            },

            async refreshPosts() {
                let response = await this.$httpClient.request("get", "/api/instagram/recent-media", {});
                this.posts = response.data || [];
            }
        }
    }
</script>

<style lang="scss" type="text/scss">
    /** Unique Index Styles **/
</style>
